<template>
    <Popup class="ConfirmDeleteAccountPopup" :enabled="enabled" width="500px" minHeight="200px">
        <h1 class="font-size-middle">Czy na pewno chcesz usunąć konto <strong>"{{ accountEmail }}"</strong>?</h1>
        <div class="actions">
            <SmallButton @click.native="$emit('confirm')" border-color="primary">Usuń</SmallButton>
            <SmallButton @click.native="$emit('close')">Cofnij</SmallButton>
        </div>
    </Popup>
</template>

<script>
    import Popup from '@/components/generic/Popup.vue';
    import SmallButton from '@/components/input/SmallButton.vue';

    export default {
        name: 'ConfirmDeleteAccountPopup',
        components: {
            Popup,
            SmallButton,
        },

        props: {
            enabled: {
                type: Boolean,
                default: true,
            },
            accountEmail: {
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .ConfirmDeleteAccountPopup {
        h1 {
            margin: 0;
            margin-bottom: 20px;
            color: white;

            font-weight: normal;
        }

        .actions {
            display: flex;
            justify-content: flex-end;

            & > *:not(:last-child) {
                margin-right: 10px;
            }
        }
    }
</style>
